// @mui
import { createTheme } from "@mui/material/styles";

// A ---------------------------------------------------------------------- M

// themes
export const ArmilisTheme = createTheme({
  palette: {
    primary: {
      main: "#0B0B0F",
      dark: "#000000",
    },
    secondary: {
      main: "#f50057",
    },
    background: {
      default: "#e8ebf0",
      paper: "#ffffffee",
    },
    text: {
      primary: "#111111",
      secondary: "#444444",
    },
  },
  typography: {
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  },
});

export const TrustConserveTheme = createTheme({
  palette: {
    primary: {
      main: "#0d47a1",
      light: "#1976d2",
      dark: "#002171",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#00bfa5",
      light: "#5df2d6",
      dark: "#008e76",
      contrastText: "#ffffff",
    },
    background: {
      default: "#e8ebf0",
      paper: "#ffffffee",
    },
  },
  typography: {
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  },
});

export const AMGTheme = createTheme({
  palette: {
    primary: {
      main: "#b2102f",
    },
    secondary: {
      main: "#f50057",
    },
  },
  typography: {
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  },
});

export const AlsaTheme = createTheme({
  palette: {
    primary: {
      main: "#054e77",
    },
    secondary: {
      main: "#f50057",
    },
  },
  typography: {
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  },
});

export const WilktronicsXArmilisTheme = createTheme({
  palette: {
    primary: {
      main: "#2196f3",
    },
    secondary: {
      main: "#f50057",
    },
  },
  typography: {
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  },
});

export const _jZP9Zja79jTheme = createTheme({
  palette: {
    primary: {
      main: "#054e77",
    },
    secondary: {
      main: "#f50057",
    },
  },
  typography: {
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  },
});

export const DefaultTheme = createTheme({
  palette: {
    primary: {
      main: "#0B0B0F",
    },
    secondary: {
      main: "#f50057",
    },
  },
  typography: {
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  },
});
